import { useLocalObservable } from 'mobx-react';
import React, { createContext, ReactNode } from 'react';
import { NoteApi } from '../../api-client';
import { AuthContext } from '../Auth/auth.provider';
import useStore from '../../helpers/useStore';
import { createApiConfig } from '../../api/createApiConfig';
import NotesStore from './notesStore';
import { Note } from '@mui/icons-material';
import { PatientsContext } from '../Patients/patients.provider';



interface NotesProviderProps {
  children: ReactNode;
}

export const NotesContext = createContext<NotesStore | null>(null);
NotesContext.displayName = 'NotesContext';

export const NotesProvider = ({ children }: NotesProviderProps) => {
const AuthenticationStore = useStore(AuthContext);
const patientStore=useStore(PatientsContext)

  const apiClient = new NoteApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(
    () => new NotesStore(apiClient,AuthenticationStore,patientStore)
  );

  store.apiClient = apiClient;

  return (
    <NotesContext.Provider value={store}>
      {children}
    </NotesContext.Provider>
  );
};